import * as React from "react";
import { Edit, SelectInput, TopToolbar, TextField, ListButton } from "react-admin";

import CustomSimpleForm from "../customise/CustomSimpleForm";
import CustomToolbar from "../customise/CustomToolbar";

const VendorEditActions = ({ basePath }) => (
  <TopToolbar>
    <ListButton basePath={basePath} label={"Vendors List"} />
  </TopToolbar>
);

export const VendorEdit = (props) => {
  return (
    <Edit {...props} actions={<VendorEditActions />} >
      <CustomSimpleForm toolbar={<CustomToolbar allowDelete={false} editable={true} />}>
        <TextField source="name" />
        <TextField source="vendorKey" />
        <SelectInput
          source="serviceType"
          choices={[
            { id: "hard", name: "Hard" },
            { id: "soft", name: "Soft" },
          ]}
        />
      </CustomSimpleForm>
    </Edit>
  );
};

export default VendorEdit;
